import { createLucideIcon } from 'lucide-react';

/**
 * ZOE's mark: a Z inside a speech bubble. Built with lucide's own factory so
 * it is a real `LucideIcon` — same 24px grid, 2px round stroke and props as
 * the other sidebar icons — and can go straight into a tab's `icon` slot.
 */
const ZoeMark = createLucideIcon('ZoeMark', [
  ['path', { d: 'M7.9 20A9 9 0 1 0 4 16.1L2 22z', key: 'bubble' }],
  ['path', { d: 'M9 8.5h6l-6 7h6', key: 'z' }],
]);

export default ZoeMark;
